import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Badge from '@mui/material/Badge';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Avatar from '@mui/material/Avatar';
import CloseIcon from '@mui/icons-material/Close';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getagent } from '../redux/agent';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [gender, setgender] = React.useState("none");
  const [position, setposition] = React.useState("none");
  const [iniposition, setiniposition] = React.useState("none");
  const [employmenttype, setemploymenttype] = React.useState("none");
  const [marrital, setmarrital] = React.useState("none");
  const [personName, setPersonName] = React.useState([]);
  const [person, setperson] = React.useState("");
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const names = [
    "Mobile Phone",
    "Vehicle",
    "Motorbike",
    "Computer",
  ];

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const imagehandler = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setperson(reader.result);
      }
    };
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const resetForm = () => {
    document.getElementById("surname").value = "";
    document.getElementById("othername").value = "";
    document.getElementById("lastname").value = "";
    document.getElementById("contact").value = "";
    document.getElementById("idnumber").value = "";
    document.getElementById("ssnit").value = "";
    document.getElementById("dob").value = "";
    document.getElementById("license").value = "";
    document.getElementById("expiry").value = "";
    document.getElementById("dateemployed").value = "";
    document.getElementById("others").value = "";
    document.getElementById("fileimage").value = "";
    setgender("none");
    setposition("none");
    setiniposition("none");
    setemploymenttype("none");
    setmarrital("none");
    setPersonName([]);
    setperson("");
  };

  const addAgent = async () => {
    setloading(true);
    const file = document.getElementById("fileimage").files[0];
    const fd = new FormData();

    if (file) {
      fd.append("file", file);
      fd.append("image", file.name);
    }
    fd.append("surname", document.getElementById("surname").value);
    fd.append("othername", document.getElementById("othername").value);
    fd.append("lastname", document.getElementById("lastname").value);
    fd.append("contact", document.getElementById("contact").value);
    fd.append("idnumber", document.getElementById("idnumber").value);
    fd.append("ssnit", document.getElementById("ssnit").value);
    fd.append("gender", gender);
    fd.append("dob", document.getElementById("dob").value);
    fd.append("license", document.getElementById("license").value);
    fd.append("expiry", document.getElementById("expiry").value);
    fd.append("dateemployed", document.getElementById("dateemployed").value);
    fd.append("iniposition", iniposition);
    fd.append("position", position);
    fd.append("employmenttype", employmenttype);
    fd.append("marrital", marrital);
    fd.append("assetusage", personName);
    fd.append("others", document.getElementById("others").value);

    try {
      const response = await axios.post("https://server.agrotraciserp.com/api/agent/addagent/", fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        dispatch(getagent({ data: response.data }));
        handleSnackbarOpen("Agent Added Successfully", "success");
        resetForm();
        handleClose();
      } else {
        handleSnackbarOpen("Failed to Add Agent", "error");
      }
    } catch (err) {
      handleSnackbarOpen("Error Adding Agent", "error");
    } finally {
      setloading(false);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Add Agent
      </Button>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Add New Agent
          <IconButton onClick={handleClose} sx={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="on"
            onSubmit={(e) => { e.preventDefault(); addAgent(); }}
          >
            <Box sx={{ width: '100%', textAlign: 'center', mb: 2 }}>
              <input
                style={{ display: 'none' }}
                id="fileimage"
                type="file"
                accept="image/*"
                onChange={imagehandler}
              />
              <label htmlFor="fileimage">
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  badgeContent={
                    <CameraAltIcon sx={{ cursor: 'pointer', bgcolor: 'darkblue', p: 0.75, borderRadius: '50%', color: 'white', fontSize: 26 }} />
                  }
                >
                  <Avatar sx={{ width: 100, height: 100, border: '1px solid #f0f0f0' }} alt="Agent Photo" src={person} />
                </Badge>
              </label>
            </Box>
            <TextField
              id="surname"
              label="Surname"
              type="text"
              autoComplete="current-text"
              required
            />
            <TextField
              id="othername"
              label="Other Names"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="lastname"
              label="Last Name"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="dob"
              label="Date of Birth"
              type="date"
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
              required
            />
            <TextField
              id="idnumber"
              label="ID Number"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="ssnit"
              label="SSNIT"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="license"
              label="Driver's License Number"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="expiry"
              label="License Expiry Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
            />
            <TextField
              id="dateemployed"
              label="Date Employed"
              type="date"
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
              required
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Gender</InputLabel>
              <Select
                value={gender}
                onChange={(e) => setgender(e.target.value)}
                label="Gender"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Employment Type</InputLabel>
              <Select
                value={employmenttype}
                onChange={(e) => setemploymenttype(e.target.value)}
                label="Employment Type"
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Permanent">Permanent</MenuItem>
                <MenuItem value="Temporal">Temporal</MenuItem>
                <MenuItem value="Contract">Contract</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="contact"
              label="Contact"
              type="tel"
              autoComplete="current-text"
              required
            />
            <TextField
              id="address"
              label="Address"
              type="text"
              autoComplete="current-text"
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Marital Status</InputLabel>
              <Select
                value={marrital}
                onChange={(e) => setmarrital(e.target.value)}
                label="Marital Status"
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Single">Single</MenuItem>
                <MenuItem value="Married">Married</MenuItem>
                <MenuItem value="Divorced">Divorced</MenuItem>
                <MenuItem value="Complicated">Complicated</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Initial Position</InputLabel>
              <Select
                value={iniposition}
                onChange={(e) => setiniposition(e.target.value)}
                label="Initial Position"
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Manager">Manager</MenuItem>
                <MenuItem value="Secretary">Secretary</MenuItem>
                <MenuItem value="Field Agent">Field Agent</MenuItem>
                <MenuItem value="Sourcing Agent">Sourcing Agent</MenuItem>
                <MenuItem value="Driver">Driver</MenuItem>
                <MenuItem value="Security">Security</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Current Position</InputLabel>
              <Select
                value={position}
                onChange={(e) => setposition(e.target.value)}
                label="Current Position"
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Manager">Manager</MenuItem>
                <MenuItem value="Secretary">Secretary</MenuItem>
                <MenuItem value="Field Agent">Field Agent</MenuItem>
                <MenuItem value="Sourcing Agent">Sourcing Agent</MenuItem>
                <MenuItem value="Driver">Driver</MenuItem>
                <MenuItem value="Security">Security</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Asset Usage</InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Asset Usage" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="others"
              label="Other Descriptions"
              multiline
              rows={4}
              fullWidth
              sx={{ m: 1, width: '52ch' }}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Box sx={{ textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" disabled>Loading...</Button>
            ) : (
              <Button
                type="submit"
                variant="outlined"
                startIcon={<EngineeringIcon />}
                size="large"
                sx={{ bgcolor: '#e0eff9', color: '#1976d2' }}
                onClick={addAgent}
              >
                Add Agent
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}